import { isDevAuthBypassActive } from "@/knowmeno/devAuthBypass";

/**
 * Shared helper that maps wearable-connection errors to banner visibility.
 * Callers pass the raw error (or undefined) and receive:
 *   - `showAuthBanner` — true when the user should see the "Sign in to see
 *     your connected wearables" banner (401 / missing Supabase session / dev
 *     auth bypass).
 *   - `errorMessage`   — a user-friendly string for generic error UIs, or
 *     `null` when the auth banner is sufficient.
 */
export function classifyWearableError(
  err: unknown,
): { showAuthBanner: boolean; errorMessage: string | null } {
  // Dev auth bypass has no real Supabase session → always show auth banner.
  if (isDevAuthBypassActive()) {
    return { showAuthBanner: true, errorMessage: null };
  }

  const msg = String((err as any)?.message || "");
  const isAuthError = /unauthor|authorization|401|no authorization header/i.test(
    msg,
  );

  if (isAuthError) {
    return { showAuthBanner: true, errorMessage: null };
  }

  return {
    showAuthBanner: false,
    errorMessage: msg || "Couldn't load devices",
  };
}
